import "./Heading.scss"

type HeadingProps = {
  text: string
}

const Heading = (props: HeadingProps) => {
  return <h1 className="Heading">{props.text}</h1>
}

export default Heading
